import React from 'react'
import { MuiTextfield } from 'material-ui-elements'
import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole } = commonConfigValues

const {
  helpers: {
    keepInLength,
    calculatePeriod,
    calculateFlag,
    getLoginFromMail,
    getUserId
  }
} = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const senResubmission = [
  { id: 1, label: 'Follow-Up x 1' },
  { id: 2, label: 'Follow-Up x 2' },
  { id: 3, label: 'Follow-Up x 3' },
  { id: 4, label: 'Follow-Up x 4' },
  { id: 5, label: 'Follow-Up x 5' },
  { id: 6, label: 'Re-Submission x 1' },
  { id: 7, label: 'Re-Submission x 2' },
  { id: 8, label: 'Re-Submission x 1 & Follow-Up x 1' },
  { id: 9, label: 'Re-Submission x 1 & Follow-Up x 2' },
  { id: 10, label: 'Re-Submission x 1 & Follow-Up x 3' },
  { id: 11, label: 'Re-Submission x 2 & Follow-Up x 1' },
  { id: 12, label: 'Re-Submission x 2 & Follow-Up x 2' },
  { id: 13, label: 'Re-Submission x 2 & Follow-Up x 3' },
  { id: 14, label: 'N / A' }
]

export const senStatus = [
  { id: 1, label: 'Complaint - Review Ongoing' },
  { id: 2, label: 'CPC / D - Review Ongoing' },
  { id: 3, label: 'MCFC - Episode Ongoing' },
  { id: 4, label: 'Restrictive Practice - Use Ongoing' },
  { id: 5, label: 'SEN - Clarification / Revision Pending' },
  { id: 6, label: 'Closed' }
]

export const senElements = [
  { id: 1, label: 'Accident' },
  { id: 2, label: 'Bullying' },
  { id: 3, label: 'Child Protection Concern' },
  { id: 4, label: 'Child Protection Disclosure' },
  { id: 5, label: 'Complaint' },
  { id: 6, label: 'Conversation of Note' },
  { id: 7, label: 'Drugs / Alcohol / Solvent Use (Confirmed)' },
  { id: 8, label: 'Drugs / Alcohol / Solvent Use (Suspected)' },
  { id: 9, label: 'Fire Setting' },
  { id: 10, label: 'Follow-Up' },
  { id: 11, label: 'Garda Involvement (Excl. MCFC / Abscond)' },
  { id: 12, label: 'Incident' },
  { id: 13, label: 'Missing Child from Care' },
  { id: 14, label: 'Physical Aggression' },
  { id: 15, label: 'Potentially Unlawful Behaviour' },
  { id: 16, label: 'Property Damage' },
  { id: 17, label: 'Reference to Suicide / Self-Harm' },
  { id: 18, label: 'RP Chemical Restraint' },
  { id: 19, label: 'RP Communication Restriction / Supervision' },
  { id: 20, label: 'RP Egress Prevention - Locked Door' },
  { id: 21, label: 'RP Egress Prevention - Physical Intervention' },
  { id: 22, label: 'RP Family Access Restriction / Supervision' },
  { id: 23, label: 'RP Finance Restriction / Supervision' },
  { id: 24, label: 'RP Food Restriction / Supervision' },
  { id: 25, label: 'RP Physical Intervention' },
  { id: 26, label: 'RP Property Confiscation (Permanent)' },
  { id: 27, label: 'RP Property Confiscation (Temporary)' },
  { id: 28, label: 'RP Room Access Restriction (Managing the Environment)' },
  { id: 29, label: 'RP Room Access Restriction (Routine)' },
  { id: 30, label: 'RP Room Search' },
  { id: 31, label: 'RP Single Occupancy' },
  { id: 32, label: 'RP Single Separation' },
  { id: 33, label: 'RP Structured Time Away' },
  { id: 34, label: 'RP Use of Door Alarm' },
  { id: 35, label: 'RP Use of Metal Detector' },
  { id: 36, label: 'RP Use of Psychiatric Medication to Manage Behaviour' },
  { id: 37, label: 'RP Use of Urinalysis / Drug Testing' },
  { id: 38, label: 'RP YP Search' },
  { id: 39, label: 'Self-Harm / Suicide Attempt' },
  { id: 40, label: 'Sexual / Sexualised Behaviour' },
  {
    id: 41,
    label: 'Staff Injury Accident (First Aid / Medical Treatment Referenced)'
  },
  {
    id: 42,
    label: 'Staff Injury Accident (No Treatment Required / Referenced)'
  },
  {
    id: 43,
    label: 'Staff Injury Incident (First Aid / Medical Treatment Referenced)'
  },
  {
    id: 44,
    label: 'Staff Injury Incident (No Treatment Required / Referenced)'
  },
  { id: 45, label: 'Verbal Aggression' },
  { id: 46, label: 'YP Illness' },
  {
    id: 47,
    label: 'YP Injury Accident (First Aid / Medical Treatment Referenced)'
  },
  { id: 48, label: 'YP Injury Accident (No Treatment Required / Referenced)' },
  {
    id: 49,
    label: 'YP Injury Incident (First Aid / Medical Treatment Referenced)'
  },
  { id: 50, label: 'YP Injury Incident (No Treatment Required / Referenced)' }
]

export const practiseType = [
  { id: 1, label: 'Communication Restriction / Supervision' },
  { id: 2, label: 'Egress Prevention' },
  { id: 3, label: 'Finance Restriction / Supervision' },
  { id: 4, label: 'Food Restriction / Supervision' },
  { id: 5, label: 'Physical Intervention' },
  { id: 6, label: 'Room Access Restriction - Incident Management' },
  { id: 7, label: 'Room Access Restriction - Not Incident Related' },
  { id: 8, label: 'Single Occupancy' },
  { id: 9, label: 'Structured Time Away' },
  { id: 10, label: 'Use of Door Alarm / Door Activity Monitoring' },
  { id: 11, label: 'Use of Psychiatric Medication to Impact Behaviour' },
  { id: 12, label: 'Use of Urinalysis / Drug Testing' },
  { id: 13, label: 'Property Confiscation - Temporary' },
  { id: 14, label: 'Property Confiscation - Permanent' },
  { id: 15, label: 'Other' }
]

export const permissionType = [
  { id: 1, label: 'CM / SW Pre-Approved' },
  { id: 2, label: 'CM / SW Approved - Risk Based' },
  { id: 3, label: 'CM Approved - Risk Based' },
  { id: 4, label: 'On-Call Management Approved - Risk Based' },
  { id: 5, label: 'Line Management Approved - Risk Based' },
  { id: 6, label: 'Centre Staff Action - Risk Based' },
  { id: 7, label: 'Other' }
]

export const reviewPeriod = [
  { id: 1, label: '6 Months' },
  { id: 2, label: '12 Months' },
  { id: 3, label: '18 Months' },
  { id: 4, label: '24 Months' },
  { id: 5, label: '30 Months' },
  { id: 6, label: '36 Months' },
  { id: 7, label: '42 Months' },
  { id: 8, label: '48 Months' },
  { id: 9, label: '54 Months' },
  { id: 10, label: '60 Months' }
]

export const complaintSubject = [
  { id: 1, label: 'Placement in Care' },
  { id: 2, label: 'Placement in Residential Care' },
  { id: 3, label: 'Placement in this Centre' },
  { id: 4, label: 'Care Plan Elements' },
  { id: 5, label: 'Centre Routines / Rules' },
  { id: 6, label: 'Placement Plan Elements' },
  { id: 7, label: 'Professionals - Centre' },
  { id: 8, label: 'Professionals - GaL' },
  { id: 9, label: 'Professionals - Other' },
  { id: 10, label: 'Professionals - Social Work' },
  { id: 11, label: 'Other' }
]

export const protectionType = [
  { id: 1, label: 'Child Protection Concern' },
  { id: 2, label: 'Child Protection Disclosure' }
]

export const protectionCategory = [
  { id: 1, label: 'Abuse - Emotional' },
  { id: 2, label: 'Abuse - Physical' },
  { id: 3, label: 'Abuse - Sexual' },
  { id: 4, label: 'Neglect' },
  { id: 5, label: 'Sexual Exploitation' }
]

export const valueTable = {
  senResubmission,
  senStatus,
  senElements,
  practiseType,
  permissionType,
  reviewPeriod,
  complaintSubject,
  protectionType,
  protectionCategory
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'sen.date',
      'sen.description',
      'sen.elements',
      'childProtection.protectionType',
      'childProtection.protectionCategory',
      'childProtection.resolutionPeriod',
      'childProtection.flag',
      'complaint.subject',
      'complaint.resolutionPeriod',
      'complaint.flag',
      'mcfc.duration',
      'mcfc.flag',
      'practise.practiseType',
      'practise.permissionType',
      'practise.reviewPeriod',
      'practise.duration',
      'practise.flag',
      'sen.status',
      'sen.validFrom'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  //########################################
  // SEN
  //########################################
  {
    name: 'sen.date',
    title: 'Risk Identified Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Risk Identified '
  },
  {
    name: 'sen.referenceNumber',
    title: 'SEN Reference No.',
    formField: true,
    getCellValue: row => row['id'],
    // type: 'select',
    //auto populate from ID wit formatting
    filterField: true,
    minSpace: 'SEN Reference No. '
  },
  {
    name: 'sen.description',
    title: 'SEN Description',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Description '
  },
  {
    name: 'sen.elements',
    title: 'SEN Elements',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(senElements, ['id', parseInt(row[`sen.elements`], 10)])
        ? _.find(senElements, ['id', parseInt(row[`sen.elements`], 10)]).label
        : row[`sen.elements`],
    options: 'senElements',
    multiple: true,
    filterField: true,
    minSpace: 'Elements '
  },
  {
    name: 'sen.senResubmission',
    title: 'SEN Follow-Ups / Resubmissions',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(senResubmission, ['id', parseInt(row[`sen.senResubmission`], 10)])
        ? _.find(senResubmission, [
            'id',
            parseInt(row[`sen.senResubmission`], 10)
          ]).label
        : row[`sen.senResubmission`],
    options: 'senResubmission',
    filterField: true,
    minSpace: 'SEN Follow-Ups / '
  },
  {
    name: 'sen.status',
    title: 'SEN Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(senStatus, ['id', parseInt(row[`sen.status`], 10)])
        ? _.find(senStatus, ['id', parseInt(row[`sen.status`], 10)]).label
        : row[`sen.status`],
    options: 'senStatus',
    filterField: true,
    minSpace: 'Status '
  },
  {
    name: 'sen.validFrom',
    title: 'SEN Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Valid at Date '
  },
  //########################################
  // CHILD PROTECTION
  //########################################
  {
    name: 'childProtection.protectionType',
    title: 'Child Protection Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(protectionType, [
        'id',
        parseInt(row[`childProtection.protectionType`], 10)
      ])
        ? _.find(protectionType, [
            'id',
            parseInt(row[`childProtection.protectionType`], 10)
          ]).label
        : row[`childProtection.protectionType`],
    options: 'protectionType',
    filterField: true,
    minSpace: 'Child Protection '
  },
  {
    name: 'childProtection.protectionCategory',
    title: 'Child Protection Category',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(protectionCategory, [
        'id',
        parseInt(row[`childProtection.protectionCategory`], 10)
      ])
        ? _.find(protectionCategory, [
            'id',
            parseInt(row[`childProtection.protectionCategory`], 10)
          ]).label
        : row[`childProtection.protectionCategory`],
    options: 'protectionCategory',
    multiple: true,
    filterField: true,
    minSpace: 'Child Protection '
  },
  {
    name: 'childProtection.personDisclosing',
    title: 'Concerned Person / Person Disclosing Name(s)',
    formField: true,
    maxChars: 50,
    filterField: true,
    minSpace: 'Concerned Person / Person '
  },
  {
    name: 'childProtection.theirRoleDisclosing',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, [
        'id',
        parseInt(row[`childProtection.theirRoleDisclosing`], 10)
      ])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`childProtection.theirRoleDisclosing`], 10)
          ]).label
        : row[`childProtection.theirRoleDisclosing`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'childProtection.date',
    title: 'Concern / Disclosure Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Disclosure Date '
  },
  {
    name: 'childProtection.time',
    title: 'Concern / Disclosure Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Disclosure Time '
  },
  {
    name: 'childProtection.closedDate',
    title: 'Child Protection C/D Closed Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Child Protection '
  },
  {
    name: 'childProtection.resolutionPeriod',
    title: 'Child Protection C/D Resolution Period',
    formField: true,
    getCellValue: row =>
      calculatePeriod(
        row[`childProtection.disclosureDate`],
        row[`childProtection.closedDate`]
      ),
    // type: 'time',
    //calculated field
    filterField: true,
    minSpace: 'Child Protection C/D '
  },
  {
    name: 'childProtection.flag',
    title: 'Child Protection C/D Flag',
    formField: true,
    // type: 'boolean',
    filterField: true,
    minSpace: 'Child Protection '
  },

  //########################################
  // COMPLAINT
  //########################################

  {
    name: 'complaint.subject',
    title: 'Complaint Subject',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(complaintSubject, ['id', parseInt(row[`complaint.subject`], 10)])
        ? _.find(complaintSubject, [
            'id',
            parseInt(row[`complaint.subject`], 10)
          ]).label
        : row[`complaint.subject`],
    options: 'complaintSubject',
    multiple: true,
    filterField: true,
    minSpace: 'Complaint '
  },
  {
    name: 'complaint.recipientName',
    title: 'Complaint Recipient Name(s)',
    formField: true,
    maxChars: 100,
    filterField: true,
    minSpace: 'Recipient Name(s)  '
  },
  {
    name: 'complaint.theirRoleRecipient',
    title: 'Their Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, [
        'id',
        parseInt(row[`complaint.theirRoleRecipient`], 10)
      ])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`complaint.theirRoleRecipient`], 10)
          ]).label
        : row[`complaint.theirRoleRecipient`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'complaint.receivedDate',
    title: 'Complaint Received Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Received Date '
  },
  {
    name: 'complaint.receivedTime',
    title: 'Complaint Received Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Received Time '
  },
  {
    name: 'complaint.resolvedDate',
    title: 'Complaint Resolved Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Resolved Date '
  },
  {
    name: 'complaint.resolutionPeriod',
    title: 'Complaint Resolution Period',
    formField: true,
    getCellValue: row =>
      calculatePeriod(
        row[`complaint.receivedDate`],
        row[`complaint.resolvedDate`]
      ),
    //calculated field
    filterField: true,
    minSpace: 'Resolution Period '
  },
  {
    name: 'complaint.flag',
    title: 'Complaint Flag',
    formField: true,
    // type: 'boolean',
    filterField: true,
    minSpace: 'Complaint Flag '
  },

  //########################################
  // MCFC
  //########################################
  {
    name: 'mcfc.startDate',
    title: 'MCFC Start Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Start Date   '
  },
  {
    name: 'mcfc.startTime',
    title: 'MCFC Start Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Start Time   '
  },
  {
    name: 'mcfc.endDate',
    title: 'MCFC End Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'End Date   '
  },
  {
    name: 'mcfc.endTime',
    title: 'MCFC End Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'End Time   '
  },
  {
    name: 'mcfc.duration',
    title: 'MCFC Duration',
    formField: true,
    getCellValue: row =>
      calculatePeriod(row[`mcfc.startDate`], row[`mcfc.endDate`]),
    //calculated field
    filterField: true,
    minSpace: 'Duration '
  },
  {
    name: 'mcfc.flag',
    title: 'MCFC Flag',
    formField: true,
    // type: 'boolean',
    filterField: true,
    minSpace: 'MCFC Flag '
  },
  //########################################
  // RESTRICTIVE PRACTISE
  //########################################

  {
    name: 'practise.practiseType',
    title: 'Restrictive Practice Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(practiseType, ['id', parseInt(row[`practise.practiseType`], 10)])
        ? _.find(practiseType, [
            'id',
            parseInt(row[`practise.practiseType`], 10)
          ]).label
        : row[`practise.practiseType`],
    options: 'practiseType',
    multiple: true,
    filterField: true,
    minSpace: 'Practice Type '
  },
  {
    name: 'practise.permissionType',
    title: 'Restrictive Practice Permission Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(permissionType, [
        'id',
        parseInt(row[`practise.permissionType`], 10)
      ])
        ? _.find(permissionType, [
            'id',
            parseInt(row[`practise.permissionType`], 10)
          ]).label
        : row[`practise.permissionType`],
    options: 'permissionType',
    multiple: true,
    filterField: true,
    minSpace: 'Restrictive Practice '
  },
  {
    name: 'practise.reviewPeriod',
    title: 'Pre-Approval Review Period',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(reviewPeriod, ['id', parseInt(row[`practise.reviewPeriod`], 10)])
        ? _.find(reviewPeriod, [
            'id',
            parseInt(row[`practise.reviewPeriod`], 10)
          ]).label
        : row[`practise.reviewPeriod`],
    options: 'reviewPeriod',
    filterField: true,
    minSpace: 'Pre-Approval Review Period '
  },
  {
    name: 'practise.startDate',
    title: 'Restrictive Practise Start Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Restrictive Practise '
  },
  {
    name: 'practise.startTime',
    title: 'Restrictive Practise Start Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Restrictive Practise '
  },
  {
    name: 'practise.endDate',
    title: 'Restrictive Practise End Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Restrictive Practise '
  },
  {
    name: 'practise.endTime',
    title: 'Restrictive Practise End Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Restrictive Practise '
  },
  {
    name: 'practise.duration',
    title: 'Restrictive Practise Duration',
    formField: true,
    getCellValue: row =>
      calculatePeriod(row[`practise.startDate`], row[`practise.endDate`]),
    //calculated field
    filterField: true,
    minSpace: 'Restrictive Practise '
  },
  {
    name: 'practise.flag',
    title: 'Restrictive Practise Pre-Approval Flag',
    formField: true,
    // type: 'boolean',
    filterField: true,
    minSpace: 'Restrictive Practise '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues,
  activeFormName
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'sen',
      historyName: 'senHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          // hint: 'Select Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'sen',
      disabled: activeFormName !== 'sen',
      activeName: 'sen',
      historyName: 'senHistory',
      label: 'Significant Events',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'sen.date',
            hintText: 'Select Date',
            label: 'Risk Identified Date',
            disabled: !add && (disabled || activeFormName !== 'sen'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'sen' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'sen.referenceNumber',
            label: 'SEN Reference No.',
            disabled: true
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'sen.description',
          label: 'SEN Description',
          disabled: !add && (disabled || activeFormName !== 'sen'),
          // hint: 'Enter Description',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v =>
            activeFormName !== 'sen' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'sen.elements',
            label: 'SEN Elements',
            disabled: !add && (disabled || activeFormName !== 'sen'),
            // hint: 'Select Element(s)',
            required: showAsterix,
            multiple: true,
            validate: v =>
              activeFormName !== 'sen' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.senElements
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'sen.senResubmission',
            label: 'SEN Follow-Ups / Resubmissions',
            disabled: !add && (disabled || activeFormName !== 'sen'),
            // hint: 'Select Resubmission',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'sen' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.senResubmission
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'sen.status',
            label: 'SEN Status',
            disabled: !add && (disabled || activeFormName !== 'sen'),
            // hint: 'Select Status',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'sen' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.senStatus.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'sen.validFrom',
            hintText: 'Select Date',
            label: 'SEN Status Valid at Date',
            disabled: !add && (disabled || activeFormName !== 'sen'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'sen' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ]
      ]
    },
    {
      id: 3,
      name: 'chp',
      disabled: activeFormName !== 'chp',
      activeName: 'childProtection',
      historyName: 'childProtectionHistory',
      label: 'Child Protection',
      hidden:
        formValues &&
        formValues.sen &&
        _.intersection([3, 4], formValues.sen.elements || []).length === 0,
      icon: 'note',
      fields: [
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'childProtection.protectionType',
            label: 'Child Protection Type',
            disabled: !add && (disabled || activeFormName !== 'chp'),
            // hint: 'Select Type',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'chp' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.protectionType
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'childProtection.protectionCategory',
            label: 'Child Protection Category',
            disabled: !add && (disabled || activeFormName !== 'chp'),
            // hint: 'Select Type',
            multiple: true,
            required: showAsterix,
            validate: v =>
              activeFormName !== 'chp' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.protectionCategory
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'childProtection.personDisclosing',
            label: 'Concerned Person / Person Disclosing Name(s)',
            disabled: !add && (disabled || activeFormName !== 'chp'),
            // hint: 'Enter Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'chp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'childProtection.theirRoleDisclosing',
            label: 'Their Role(s)',
            disabled: !add && (disabled || activeFormName !== 'chp'),
            multiple: true,
            required: showAsterix,
            validate: v =>
              activeFormName !== 'chp' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'childProtection.disclosureDate',
            hintText: 'Select Date',
            label: 'Concern / Disclosure Date',
            disabled: !add && (disabled || activeFormName !== 'chp'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'childProtection.actionflag',
                calculateFlag(
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.closedDate,
                  v
                )
              )
              change(
                formName,
                'childProtection.resolutionPeriod',
                calculatePeriod(
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.closedDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'chp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'childProtection.disclosureTime',
            hintText: 'Select Time',
            label: 'Concern / Disclosure Time',
            disabled: !add && (disabled || activeFormName !== 'chp'),
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'chp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'childProtection.closedDate',
            hintText: 'Select Date',
            label: 'Child Protection C/D Closed Date',
            disabled: !add && (disabled || activeFormName !== 'chp'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'childProtection.actionflag',
                calculateFlag(
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.disclosureDate,
                  v
                )
              )
              change(
                formName,
                'childProtection.resolutionPeriod',
                calculatePeriod(
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.disclosureDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'chp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'childProtection.resolutionPeriod',
            label: 'Child Protection C/D Resolution Period',
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculatePeriod(
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.disclosureDate,
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.closedDate
                )}
                label={'Child Protection C/D Resolution Period'}
              />
            ),
            required: showAsterix
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculateFlag(
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.disclosureDate,
                  formValues &&
                    formValues.childProtection &&
                    formValues.childProtection.closedDate
                )}
                label={'Child Protection C/D Flag'}
              />
            ),
            name: 'childProtection.flag',
            label: 'Child Protection C/D Flag'
          }
        ]
      ]
    },
    {
      id: 4,
      name: 'cmp',
      disabled: activeFormName !== 'cmp',
      activeName: 'complaint',
      historyName: 'complaintHistory',
      label: 'Complaint',
      hidden:
        formValues &&
        formValues.sen &&
        _.intersection([5], formValues.sen.elements || []).length === 0,
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'complaint.subject',
          multiple: true,
          label: 'Complaint Subject',
          disabled: !add && (disabled || activeFormName !== 'cmp'),
          // hint: 'Select Subject',
          required: showAsterix,
          validate: v =>
            activeFormName !== 'cmp' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.complaintSubject
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'complaint.recipientName',
            label: 'Complaint Recipient Name(s)',
            disabled: !add && (disabled || activeFormName !== 'cmp'),
            // hint: 'Enter Name(s)',
            normalize: v => {
              const val = keepInLength(v, 100)
              return val
            },
            validate: v =>
              activeFormName !== 'cmp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'complaint.theirRoleRecipient',
            label: 'Their Role(s)',
            disabled: !add && (disabled || activeFormName !== 'cmp'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'cmp' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'complaint.receivedDate',
            hintText: 'Select Date',
            label: 'Complaint Received Date',
            disabled: !add && (disabled || activeFormName !== 'cmp'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'complaint.flag',
                calculateFlag(
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.resolvedDate,
                  v
                )
              )
              change(
                formName,
                'complaint.resolutionPeriod',
                calculatePeriod(
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.resolvedDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'cmp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'complaint.receivedTime',
            hintText: 'Select Time',
            label: 'Complaint Received Time',
            disabled: !add && (disabled || activeFormName !== 'cmp'),
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'cmp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },

          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'complaint.resolvedDate',
            hintText: 'Select Date',
            label: 'Complaint Resolved Date',
            disabled: !add && (disabled || activeFormName !== 'cmp'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'complaint.flag',
                calculateFlag(
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.receivedDate,
                  v
                )
              )
              change(
                formName,
                'complaint.resolutionPeriod',
                calculatePeriod(
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.receivedDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'cmp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'complaint.resolutionPeriod',
            label: 'Complaint Resolution Period',
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculatePeriod(
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.receivedDate,
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.resolvedDate
                )}
                label={'Complaint Resolution Period'}
              />
            ),
            required: showAsterix
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculateFlag(
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.receivedDate,
                  formValues &&
                    formValues.complaint &&
                    formValues.complaint.resolvedDate
                )}
                label={'Complaint Flag'}
              />
            ),
            name: 'complaint.flag',
            label: 'Complaint Flag'
          }
        ]
      ]
    },
    {
      id: 5,
      name: 'mcf',
      disabled: activeFormName !== 'mcf',
      activeName: 'mcfc',
      historyName: 'mcfcHistory',
      label: 'MCFC',
      icon: 'note',
      hidden:
        formValues &&
        formValues.sen &&
        _.intersection([11], formValues.sen.elements || []).length === 0,
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'mcfc.startDate',
            hintText: 'Select Date',
            label: 'MCFC Start Date',
            disabled: !add && (disabled || activeFormName !== 'mcf'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'mcfc.flag',
                calculateFlag(
                  formValues && formValues.mcfc && formValues.mcfc.endDate,
                  v
                )
              )
              change(
                formName,
                'mcfc.duration',
                calculatePeriod(
                  formValues && formValues.mcfc && formValues.mcfc.endDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'mcf' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'mcfc.startTime',
            hintText: 'Select Time',
            label: 'MCFC Start Time',
            disabled: !add && (disabled || activeFormName !== 'mcf'),
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'mcf' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'mcfc.endDate',
            hintText: 'Select Date',
            label: 'MCFC End Date',
            disabled: !add && (disabled || activeFormName !== 'mcf'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'mcfc.flag',
                calculateFlag(
                  formValues && formValues.mcfc && formValues.mcfc.startDate,
                  v
                )
              )
              change(
                formName,
                'mcfc.duration',
                calculatePeriod(
                  formValues && formValues.mcfc && formValues.mcfc.startDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'mcf' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'mcfc.endTime',
            hintText: 'Select Time',
            label: 'MCFC End Time',
            disabled: !add && (disabled || activeFormName !== 'mcf'),
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'mcf' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'mcfc.duration',
            label: 'MCFC Duration',
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculatePeriod(
                  formValues && formValues.mcfc && formValues.mcfc.startDate,
                  formValues && formValues.mcfc && formValues.mcfc.endDate
                )}
                label={'MCFC Duration'}
              />
            ),
            required: showAsterix
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculateFlag(
                  formValues && formValues.mcfc && formValues.mcfc.startDate,
                  formValues && formValues.mcfc && formValues.mcfc.endDate
                )}
                label={'MCFC Flag'}
              />
            ),
            name: 'mcfc.flag',
            label: 'MCFC Flag'
          }
        ]
      ]
    },
    {
      id: 6,
      name: 'pra',
      disabled: activeFormName !== 'pra',
      activeName: 'practise',
      historyName: 'practiseHistory',
      label: 'Restrictive Practice',
      hidden:
        formValues &&
        formValues.sen &&
        _.intersection(
          _.fill(Array(21), 0).map((k, i) => i + 18),
          formValues.sen.elements || []
        ).length === 0,
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'practise.practiseType',
          label: 'Restrictive Practice Type',
          disabled: !add && (disabled || activeFormName !== 'pra'),
          // hint: 'Select Type',
          required: showAsterix,
          multiple: true,
          validate: v =>
            activeFormName !== 'pra' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.practiseType.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'practise.permissionType',
          label: 'Restrictive Practice Permission Type',
          disabled: !add && (disabled || activeFormName !== 'pra'),
          // hint: 'Select Type',
          required: showAsterix,
          multiple: true,
          validate: v =>
            activeFormName !== 'pra' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.permissionType
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'practise.reviewPeriod',
          label: 'Pre-Approval Review Period',
          disabled: !add && (disabled || activeFormName !== 'pra'),
          // hint: 'Select Period',
          required: showAsterix,
          validate: v =>
            activeFormName !== 'pra' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.reviewPeriod.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'practise.startDate',
            hintText: 'Select Date',
            label: 'Restrictive Practise Start Date',
            disabled: !add && (disabled || activeFormName !== 'pra'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'practise.flag',
                calculateFlag(
                  formValues &&
                    formValues.practise &&
                    formValues.practise.endDate,
                  v
                )
              )
              change(
                formName,
                'practise.duration',
                calculatePeriod(
                  formValues &&
                    formValues.practise &&
                    formValues.practise.endDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'pra' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'practise.startTime',
            hintText: 'Select Time',
            label: 'Restrictive Practise Start Time',
            disabled: !add && (disabled || activeFormName !== 'pra'),
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'pra' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'practise.endDate',
            hintText: 'Select Date',
            label: 'Restrictive Practise End Date',
            disabled: !add && (disabled || activeFormName !== 'pra'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'practise.flag',
                calculateFlag(
                  formValues &&
                    formValues.practise &&
                    formValues.practise.startDate,
                  v
                )
              )
              change(
                formName,
                'practise.duration',
                calculatePeriod(
                  formValues &&
                    formValues.practise &&
                    formValues.practise.startDate,
                  v
                )
              )
            },
            validate: v =>
              activeFormName !== 'pra' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'practise.endTime',
            hintText: 'Select Time',
            label: 'Restrictive Practise End Time',
            disabled: !add && (disabled || activeFormName !== 'pra'),
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'pra' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'practise.duration',
            label: 'Restrictive Practise Duration',
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculatePeriod(
                  formValues &&
                    formValues.practise &&
                    formValues.practise.startDate,
                  formValues &&
                    formValues.practise &&
                    formValues.practise.endDate
                )}
                label={'Restrictive Practise Duration'}
              />
            ),
            required: showAsterix
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            disabled: true,
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculateFlag(
                  formValues &&
                    formValues.practise &&
                    formValues.practise.startDate,
                  formValues &&
                    formValues.practise &&
                    formValues.practise.endDate
                )}
                label={'Restrictive Practise Pre-Approval Flag'}
              />
            ),
            name: 'practise.flag',
            label: 'Restrictive Practise Pre-Approval Flag'
          }
        ]
      ]
    }
  ]

  return forms
}

export const activeSection = [
  'sen',
  'childProtection',
  'complaint',
  'mcfc',
  'practise'
]

export const errors = [1, 2]

export const defaultNew = {
  sen: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  senHistory: [],
  childProtection: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  childProtectionHistory: [],

  complaint: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  complaintHistory: [],
  mcfc: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  mcfcHistory: [],
  practise: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  practiseHistory: []
}

// "significantEvents":
// [{
//   "sen": {
//     "id": 1,
//     "registerId": 1, //  ->  "personId": 2 -> person,
//     "date": "2001-01-01T23:28:56.782Z",
//     "description":"description",
//     "elements":5,
//     "senResubmission": 1,
//     "status": 1,
//     "validFrom": "2001-01-01T23:28:56.782Z"
//   },
//   "childProtection":{
//     "protectionType": 1,
//     "protectionCategory": 1,
//     "personDisclosing": "aaa",
//     "theirRoleDisclosing": 1,
//     "disclosureDate": "2001-01-01T23:28:56.782Z",
//     "disclosureTime": "T23:28:56.782Z",
//     "closedDate": "2001-01-01T23:28:56.782Z",
//     "resolutionPeriod":"T23:28:56.782Z",
//     "flag": "flag",
//   },
//   "complaint":{
//     "subject",
//     "recipientName":"ddd",
//     "theirRoleRecipient": 2,
//     "receivedDate": "2001-01-01T23:28:56.782Z",
//     "receivedTime": "T23:28:56.782Z",
//     "resolvedDate": "2001-01-01T23:28:56.782Z",
//     "flag",
//   },
//   "mcfc":{
//     "startDate": "2001-01-01T23:28:56.782Z",
//     "startTime": "T23:28:56.782Z",
//     "endDate": "2001-01-01T23:28:56.782Z",
//     "endTime": "T23:28:56.782Z",
//     "flag",
//   },
//   "practise":{
//     "practiseType": 1,
//     "permissionType": 2,
//     "reviewPeriod": 3,
//     "startDate":"2001-01-01T23:28:56.782Z" ,
//     "startTime":"T23:28:56.782Z" ,
//     "endDate":"2001-01-01T23:28:56.782Z" ,
//     "endTime":"T23:28:56.782Z" ,
//   },
//   "senHistory": [],
//   "childProtectionHistory":[],
//   "complaintHistory":[],
//   "mcfcHistory":[],
//   "practiseHistory":[]
// }]



// WEBPACK FOOTER //
// ./src/register/configs/significantEvents.js